import React from "react";

import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Redirect } from "react-router-dom";
import { bindActionCreators } from "redux";

import { logout } from "../../actions/baseActions";

class ProtectedRoute extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: false
    };
  }

  componentDidMount() {
    const { routeId } = this.props;
    if (routeId) {
      this.checkRoutePermission(routeId);
    }
  }

  componentDidUpdate(prevProps) {
    const roleChanged =
      prevProps.general.active_roles?.role_id !==
      this.props.general.active_roles?.role_id;

    const routesChanged =
      JSON.stringify(prevProps.general.userRoutes) !==
      JSON.stringify(this.props.general.userRoutes);

    if ((roleChanged || routesChanged) && this.props.routeId) {
      this.checkRoutePermission(this.props.routeId);
    }
  }

  checkRoutePermission(route) {
    try {
      const { userRoutes } = this.props.general;
      const allowed = userRoutes.some(item => item.link_id === route);

      this.setState({ redirect: !allowed });

      if (!allowed) {
        toastr.error(`🚫 Acesso negado para a rota: ${route}`);
      }
    } catch (error) {
      toastr.error("Erro ao verificar permissões:", error);
    }
  }

  render() {
    return <>{this.state.redirect && <Redirect to="/dashboard" />}</>;
  }
}

const mapStateToProps = state => ({
  general: state.general,
  user: state.user
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      logout
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ProtectedRoute);
